@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(1_360_514_944)
public val Res.string.MAIN_NAVIGATION_CHAT_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_CHAT_LABEL", "MAIN_NAVIGATION_CHAT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13697, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13677, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14097, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12329, 42),
      ))
    }

@delegate:ResourceContentHash(-1_137_962_096)
public val Res.string.MAIN_NAVIGATION_DAILY_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_DAILY_LABEL", "MAIN_NAVIGATION_DAILY_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13740, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13720, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14140, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12372, 43),
      ))
    }

@delegate:ResourceContentHash(1_170_661_875)
public val Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_INSIGHTS_LABEL", "MAIN_NAVIGATION_INSIGHTS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13788, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13764, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14188, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12416, 50),
      ))
    }

@delegate:ResourceContentHash(-1_446_105_502)
public val Res.string.MAIN_NAVIGATION_MAIN_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_MAIN_LABEL", "MAIN_NAVIGATION_MAIN_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13839, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13819, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14239, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12467, 42),
      ))
    }

@delegate:ResourceContentHash(1_575_095_729)
public val Res.string.MAIN_NAVIGATION_ME_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_ME_LABEL", "MAIN_NAVIGATION_ME_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13882, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13866, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14286, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12510, 36),
      ))
    }

@delegate:ResourceContentHash(1_804_211_963)
public val Res.string.MAIN_NAVIGATION_TODAY_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_TODAY_LABEL", "MAIN_NAVIGATION_TODAY_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13919, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13903, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14323, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12547, 43),
      ))
    }

@delegate:ResourceContentHash(1_246_201_306)
public val Res.string.MEAL_PLAN_LOG_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:MEAL_PLAN_LOG_FOOD_BUTTON", "MEAL_PLAN_LOG_FOOD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13963, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13943, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14375, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12591, 37),
      ))
    }

@delegate:ResourceContentHash(1_804_211_963)
public val Res.string.MED_TODAY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:MED_TODAY_SCREEN_TITLE", "MED_TODAY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14009, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13989, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14421, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12629, 38),
      ))
    }

@delegate:ResourceContentHash(-749_929_503)
public val Res.string.MED_TODAY_STEPS_FORMAT: StringResource by lazy {
      StringResource("string:MED_TODAY_STEPS_FORMAT", "MED_TODAY_STEPS_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14048, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14024, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14468, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12668, 54),
      ))
    }

@delegate:ResourceContentHash(-42_542_446)
public val Res.string.ME_BMI_GOAL_VALUE_FORMAT: StringResource by lazy {
      StringResource("string:ME_BMI_GOAL_VALUE_FORMAT", "ME_BMI_GOAL_VALUE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14107, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14079, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14527, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12723, 48),
      ))
    }

@delegate:ResourceContentHash(-329_178_362)
public val Res.string.ME_CALORIES_HISTORY_SECTION: StringResource by lazy {
      StringResource("string:ME_CALORIES_HISTORY_SECTION", "ME_CALORIES_HISTORY_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14156, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14128, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14580, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12772, 55),
      ))
    }

@delegate:ResourceContentHash(1_433_218_705)
public val Res.string.ME_DAYS_IN_A_ROW_LABEL: StringResource by lazy {
      StringResource("string:ME_DAYS_IN_A_ROW_LABEL", "ME_DAYS_IN_A_ROW_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14216, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14188, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14640, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12828, 50),
      ))
    }

@delegate:ResourceContentHash(-822_320_504)
public val Res.string.ME_DAYS_IN_A_ROW_VALUE: StringResource by lazy {
      StringResource("string:ME_DAYS_IN_A_ROW_VALUE", "ME_DAYS_IN_A_ROW_VALUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14267, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14239, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14695, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12879, 42),
      ))
    }

@delegate:ResourceContentHash(1_073_534_209)
public val Res.string.ME_SCREEN_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:ME_SCREEN_TITLE_FORMAT", "ME_SCREEN_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14310, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14282, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14738, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12922, 42),
      ))
    }

@delegate:ResourceContentHash(-868_011_285)
public val Res.string.ME_WEIGHT_HISTORY_SECTION: StringResource by lazy {
      StringResource("string:ME_WEIGHT_HISTORY_SECTION", "ME_WEIGHT_HISTORY_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14357, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14329, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14789, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12965, 53),
      ))
    }

@delegate:ResourceContentHash(491_644_770)
public val Res.string.ME_WEIGHT_LOSS_PROGRESS_SECTION: StringResource by lazy {
      StringResource("string:ME_WEIGHT_LOSS_PROGRESS_SECTION", "ME_WEIGHT_LOSS_PROGRESS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14419, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14387, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14847, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13019, 67),
      ))
    }

@delegate:ResourceContentHash(-1_866_679_093)
public val Res.string.ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT: StringResource by lazy {
      StringResource("string:ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", "ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14503, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14467, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14923, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13087, 56),
      ))
    }

@delegate:ResourceContentHash(-667_220_354)
public val Res.string.ONBOARDING_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_SIGN_IN_BUTTON", "ONBOARDING_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14564, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14532, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14984, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13144, 69),
      ))
    }

@delegate:ResourceContentHash(-612_778_821)
public val Res.string.ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", "ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14634, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14594, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15046, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13214, 68),
      ))
    }

@delegate:ResourceContentHash(1_321_946_988)
public val Res.string.ONBOARDING_WELCOME_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_WELCOME_SIGN_IN_BUTTON", "ONBOARDING_WELCOME_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14707, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14659, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15119, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13283, 53),
      ))
    }

@delegate:ResourceContentHash(1_840_608_878)
public val Res.string.ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL: StringResource by lazy {
      StringResource("string:ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", "ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14761, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14721, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15177, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13337, 79),
      ))
    }

@delegate:ResourceContentHash(1_899_358_290)
public val Res.string.ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT: StringResource by lazy {
      StringResource("string:ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", "ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14841, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14813, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15273, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13417, 67),
      ))
    }

@delegate:ResourceContentHash(-434_257_612)
public val Res.string.PAYWALL_OTHER_PLANS_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_OTHER_PLANS_BUTTON", "PAYWALL_OTHER_PLANS_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14909, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14881, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15345, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13485, 54),
      ))
    }

@delegate:ResourceContentHash(-430_803_099)
public val Res.string.PAYWALL_PRIVACY_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_PRIVACY_BUTTON", "PAYWALL_PRIVACY_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14972, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14940, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15408, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13540, 42),
      ))
    }

@delegate:ResourceContentHash(-2_009_504_988)
public val Res.string.PAYWALL_RESTORE_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_RESTORE_BUTTON", "PAYWALL_RESTORE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15019, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14987, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15463, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13583, 54),
      ))
    }

@delegate:ResourceContentHash(442_198_980)
public val Res.string.PAYWALL_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_SIGN_IN_BUTTON", "PAYWALL_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15078, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15042, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15518, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13638, 38),
      ))
    }

@delegate:ResourceContentHash(1_355_438_298)
public val Res.string.PAYWALL_TERMS_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_TERMS_BUTTON", "PAYWALL_TERMS_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15121, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15093, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15565, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13677, 36),
      ))
    }

@delegate:ResourceContentHash(-1_443_397_717)
public val Res.string.PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT: StringResource by lazy {
      StringResource("string:PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", "PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15166, 203),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15134, 183),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15626, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13714, 167),
      ))
    }

@delegate:ResourceContentHash(-1_391_972_132)
public val Res.string.PCOS_TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:PCOS_TODAY_LOG_SYMPTOMS_LABEL", "PCOS_TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15370, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15318, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15830, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13882, 53),
      ))
    }

@delegate:ResourceContentHash(-1_957_927_347)
public val Res.string.PERIOD_TRACKER_DAY_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_DAY_FORMAT", "PERIOD_TRACKER_DAY_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15440, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15384, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15904, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13936, 45),
      ))
    }

@delegate:ResourceContentHash(817_180_637)
public val Res.string.PERIOD_TRACKER_LOG_BUTTON_DEFAULT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_LOG_BUTTON_DEFAULT", "PERIOD_TRACKER_LOG_BUTTON_DEFAULT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15486, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15430, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15950, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13982, 57),
      ))
    }

@delegate:ResourceContentHash(-153_622_806)
public val Res.string.PERIOD_TRACKER_LOG_BUTTON_UNDEFINED: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_LOG_BUTTON_UNDEFINED", "PERIOD_TRACKER_LOG_BUTTON_UNDEFINED", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15556, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15500, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16028, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14040, 55),
      ))
    }

@delegate:ResourceContentHash(906_819_632)
public val Res.string.PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE", "PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15620, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15564, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16092, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14096, 108),
      ))
    }

@delegate:ResourceContentHash(-864_271_601)
public val Res.string.PERIOD_TRACKER_PERIOD_LATE_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_LATE_FORMAT", "PERIOD_TRACKER_PERIOD_LATE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15745, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15697, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16233, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14205, 81),
      ))
    }

@delegate:ResourceContentHash(-1_304_499_306)
public val Res.string.PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT", "PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15839, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15791, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16323, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14287, 88),
      ))
    }

@delegate:ResourceContentHash(1_179_383_487)
public val Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT", "PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15940, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15892, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16424, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14376, 90),
      ))
    }

@delegate:ResourceContentHash(1_297_519_597)
public val Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT", "PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16047, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15995, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16531, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14467, 97),
      ))
    }

@delegate:ResourceContentHash(-857_941_281)
public val Res.string.PILATES_TODAY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:PILATES_TODAY_SCREEN_TITLE", "PILATES_TODAY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16165, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16109, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16645, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14565, 46),
      ))
    }

@delegate:ResourceContentHash(916_407_406)
public val Res.string.PILATES_TODAY_WORKOUTS_SECTION: StringResource by lazy {
      StringResource("string:PILATES_TODAY_WORKOUTS_SECTION", "PILATES_TODAY_WORKOUTS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16212, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16164, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16700, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14612, 50),
      ))
    }

@delegate:ResourceContentHash(17_519_830)
public val Res.string.RATE_US_ALERT_MESSAGE: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_MESSAGE", "RATE_US_ALERT_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16275, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16223, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16759, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14663, 133),
      ))
    }

@delegate:ResourceContentHash(-1_414_477_780)
public val Res.string.RATE_US_ALERT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_NEGATIVE_BUTTON", "RATE_US_ALERT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16421, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16373, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16893, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14797, 49),
      ))
    }

@delegate:ResourceContentHash(2_109_031_265)
public val Res.string.RATE_US_ALERT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_POSITIVE_BUTTON", "RATE_US_ALERT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16475, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16423, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16947, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14847, 41),
      ))
    }

@delegate:ResourceContentHash(1_478_310_311)
public val Res.string.RATE_US_ALERT_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_TITLE_FORMAT", "RATE_US_ALERT_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16517, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16465, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16989, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14889, 58),
      ))
    }

@delegate:ResourceContentHash(-1_382_461_745)
public val Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", "RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16572, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16520, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17044, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14948, 49),
      ))
    }

@delegate:ResourceContentHash(2_109_031_265)
public val Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", "RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16626, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16570, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17094, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14998, 49),
      ))
    }

@delegate:ResourceContentHash(-778_184_641)
public val Res.string.RATE_US_IMPROVE_ALERT_TITLE: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_TITLE", "RATE_US_IMPROVE_ALERT_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16676, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16620, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17144, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15048, 95),
      ))
    }

@delegate:ResourceContentHash(1_202_229_343)
public val Res.string.RECIPE_INGREDIENTS_TITLE: StringResource by lazy {
      StringResource("string:RECIPE_INGREDIENTS_TITLE", "RECIPE_INGREDIENTS_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16788, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16700, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17268, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15144, 48),
      ))
    }

@delegate:ResourceContentHash(2_086_933_056)
public val Res.string.RECIPE_INGREDIENT_FORMAT: StringResource by lazy {
      StringResource("string:RECIPE_INGREDIENT_FORMAT", "RECIPE_INGREDIENT_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16833, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16749, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17317, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15193, 56),
      ))
    }

@delegate:ResourceContentHash(-2_078_565_017)
public val Res.string.RECIPE_NUTRITION_CALORIES: StringResource by lazy {
      StringResource("string:RECIPE_NUTRITION_CALORIES", "RECIPE_NUTRITION_CALORIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16890, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16806, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17374, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15250, 45),
      ))
    }

@delegate:ResourceContentHash(1_581_632_898)
public val Res.string.RECIPE_NUTRITION_CARBS: StringResource by lazy {
      StringResource("string:RECIPE_NUTRITION_CARBS", "RECIPE_NUTRITION_CARBS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16936, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16852, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17420, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15296, 38),
      ))
    }

@delegate:ResourceContentHash(551_794_917)
public val Res.string.RECIPE_NUTRITION_FAT: StringResource by lazy {
      StringResource("string:RECIPE_NUTRITION_FAT", "RECIPE_NUTRITION_FAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16987, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16903, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17463, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15335, 32),
      ))
    }

@delegate:ResourceContentHash(-455_173_092)
public val Res.string.RECIPE_NUTRITION_FIBER: StringResource by lazy {
      StringResource("string:RECIPE_NUTRITION_FIBER", "RECIPE_NUTRITION_FIBER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17024, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16940, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17504, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15368, 38),
      ))
    }

@delegate:ResourceContentHash(-1_589_045_987)
public val Res.string.RECIPE_NUTRITION_PER_100G: StringResource by lazy {
      StringResource("string:RECIPE_NUTRITION_PER_100G", "RECIPE_NUTRITION_PER_100G", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17075, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16979, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17543, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15407, 57),
      ))
    }

@delegate:ResourceContentHash(-304_686_775)
public val Res.string.RECIPE_NUTRITION_PROTEIN: StringResource by lazy {
      StringResource("string:RECIPE_NUTRITION_PROTEIN", "RECIPE_NUTRITION_PROTEIN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17137, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17041, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17601, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15465, 44),
      ))
    }

@delegate:ResourceContentHash(168_290_354)
public val Res.string.RECIPE_PREPARATION_TITLE: StringResource by lazy {
      StringResource("string:RECIPE_PREPARATION_TITLE", "RECIPE_PREPARATION_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17182, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17090, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17650, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15510, 48),
      ))
    }

@delegate:ResourceContentHash(-677_899_244)
public val Res.string.RECIPE_SERVING_SIZE_FORMAT: StringResource by lazy {
      StringResource("string:RECIPE_SERVING_SIZE_FORMAT", "RECIPE_SERVING_SIZE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17231, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17139, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17699, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15559, 58),
      ))
    }

@delegate:ResourceContentHash(-1_876_738_120)
public val Res.string.SETTINGS_ABOUT_PRODUCT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_ABOUT_PRODUCT_LABEL", "SETTINGS_ABOUT_PRODUCT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17294, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17194, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17754, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15618, 44),
      ))
    }

@delegate:ResourceContentHash(-919_120_266)
public val Res.string.SETTINGS_CONTACT_US_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_CONTACT_US_LABEL", "SETTINGS_CONTACT_US_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17339, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17243, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17803, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15663, 49),
      ))
    }

@delegate:ResourceContentHash(2_121_100_297)
public val Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", "SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17401, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17293, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17857, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15713, 121),
      ))
    }

@delegate:ResourceContentHash(1_790_519_803)
public val Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", "SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17559, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17423, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18003, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15835, 91),
      ))
    }

@delegate:ResourceContentHash(926_976_890)
public val Res.string.SETTINGS_DELETE_ACCOUNT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_LABEL", "SETTINGS_DELETE_ACCOUNT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17671, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17523, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18099, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15927, 73),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", "SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17749, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17609, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18185, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16001, 55),
      ))
    }

@delegate:ResourceContentHash(-644_562_671)
public val Res.string.SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", "SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17809, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17669, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18245, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16057, 75),
      ))
    }

@delegate:ResourceContentHash(868_349_927)
public val Res.string.SETTINGS_GENERAL_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_GENERAL_SECTION", "SETTINGS_GENERAL_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17889, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17757, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18325, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16133, 44),
      ))
    }

@delegate:ResourceContentHash(-1_633_703_834)
public val Res.string.SETTINGS_LEGAL_PRODUCT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_LEGAL_PRODUCT_LABEL", "SETTINGS_LEGAL_PRODUCT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17934, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17802, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18370, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16178, 44),
      ))
    }

@delegate:ResourceContentHash(-1_646_033_701)
public val Res.string.SETTINGS_LOGOUT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_LOGOUT_LABEL", "SETTINGS_LOGOUT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17987, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17847, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18415, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16223, 37),
      ))
    }

@delegate:ResourceContentHash(-227_153_204)
public val Res.string.SETTINGS_MANAGE_SUBSCRIPTION_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_MANAGE_SUBSCRIPTION_LABEL", "SETTINGS_MANAGE_SUBSCRIPTION_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18029, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17897, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18465, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16261, 70),
      ))
    }

@delegate:ResourceContentHash(1_143_149_115)
public val Res.string.SETTINGS_MEAL_PLAN_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_LABEL", "SETTINGS_MEAL_PLAN_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18100, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17972, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18536, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16332, 44),
      ))
    }

@delegate:ResourceContentHash(108_352_794)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", "SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18149, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18025, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18589, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16377, 57),
      ))
    }

@delegate:ResourceContentHash(1_521_283_486)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", "SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18207, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18083, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18647, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16435, 68),
      ))
    }

@delegate:ResourceContentHash(-1_363_397_814)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", "SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18280, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18156, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18720, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16504, 76),
      ))
    }

@delegate:ResourceContentHash(977_529_678)
public val Res.string.SETTINGS_METRICS_SYSTEM_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_METRICS_SYSTEM_LABEL", "SETTINGS_METRICS_SYSTEM_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18357, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18237, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18801, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16581, 57),
      ))
    }

@delegate:ResourceContentHash(257_028_932)
public val Res.string.SETTINGS_PERIOD_TRACKER_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PERIOD_TRACKER_LABEL", "SETTINGS_PERIOD_TRACKER_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18415, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18299, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18863, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16639, 57),
      ))
    }

@delegate:ResourceContentHash(1_671_325_192)
public val Res.string.SETTINGS_PROFILE_AGE_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_AGE_LABEL", "SETTINGS_PROFILE_AGE_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18473, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18369, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18925, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16697, 38),
      ))
    }

@delegate:ResourceContentHash(-378_224_604)
public val Res.string.SETTINGS_PROFILE_HEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_HEIGHT_LABEL", "SETTINGS_PROFILE_HEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18516, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18412, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18968, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16736, 45),
      ))
    }

@delegate:ResourceContentHash(1_929_799_358)
public val Res.string.SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", "SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18566, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18458, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19014, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16782, 65),
      ))
    }

@delegate:ResourceContentHash(-1_053_938_601)
public val Res.string.SETTINGS_PROFILE_NAME_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_NAME_LABEL", "SETTINGS_PROFILE_NAME_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18632, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18520, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19080, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16848, 43),
      ))
    }

@delegate:ResourceContentHash(-1_257_662_451)
public val Res.string.SETTINGS_PROFILE_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_SECTION", "SETTINGS_PROFILE_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18676, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18564, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19120, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16892, 44),
      ))
    }

@delegate:ResourceContentHash(737_201_588)
public val Res.string.SETTINGS_PROFILE_TARGET_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", "SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18717, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18605, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19161, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16937, 64),
      ))
    }

@delegate:ResourceContentHash(676_730_041)
public val Res.string.SETTINGS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_SCREEN_TITLE", "SETTINGS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18778, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18670, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19222, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17002, 41),
      ))
    }

@delegate:ResourceContentHash(1_278_090_331)
public val Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_CATEGORY_ALL_LABEL", "SHOPPING_LIST_CATEGORY_ALL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18828, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18720, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19268, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17044, 44),
      ))
    }

@delegate:ResourceContentHash(631_861_769)
public val Res.string.SHOPPING_LIST_CHECKED_SECTION: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_CHECKED_SECTION", "SHOPPING_LIST_CHECKED_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18877, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18769, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19317, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17089, 45),
      ))
    }

@delegate:ResourceContentHash(1_679_605_207)
public val Res.string.SHOPPING_LIST_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_SCREEN_TITLE", "SHOPPING_LIST_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18927, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18815, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19367, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17135, 54),
      ))
    }

@delegate:ResourceContentHash(-708_335_561)
public val Res.string.SHOPPING_LIST_UNCHECKED_SECTION: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_UNCHECKED_SECTION", "SHOPPING_LIST_UNCHECKED_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18982, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18874, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19426, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17190, 47),
      ))
    }

@delegate:ResourceContentHash(358_438_978)
public val Res.string.TODAY_ACTIVITY_LABEL: StringResource by lazy {
      StringResource("string:TODAY_ACTIVITY_LABEL", "TODAY_ACTIVITY_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19034, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18930, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19482, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17238, 40),
      ))
    }

@delegate:ResourceContentHash(1_439_622_758)
public val Res.string.TODAY_LOGGED_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:TODAY_LOGGED_SYMPTOMS_LABEL", "TODAY_LOGGED_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19079, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18971, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19523, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17279, 43),
      ))
    }

@delegate:ResourceContentHash(1_339_721_198)
public val Res.string.TODAY_LOG_CONTROLS_SECTION: StringResource by lazy {
      StringResource("string:TODAY_LOG_CONTROLS_SECTION", "TODAY_LOG_CONTROLS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19135, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19023, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19575, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17323, 54),
      ))
    }

@delegate:ResourceContentHash(2_107_562_047)
public val Res.string.TODAY_LOG_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_FOOD_BUTTON", "TODAY_LOG_FOOD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19198, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19082, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19638, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17378, 41),
      ))
    }

@delegate:ResourceContentHash(1_138_601_962)
public val Res.string.TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:TODAY_LOG_SYMPTOMS_LABEL", "TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19256, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19136, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19704, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17420, 48),
      ))
    }

@delegate:ResourceContentHash(-2_125_504_051)
public val Res.string.TODAY_LOG_WATER_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_WATER_BUTTON", "TODAY_LOG_WATER_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19321, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19197, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19773, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17469, 42),
      ))
    }

@delegate:ResourceContentHash(-1_396_504_514)
public val Res.string.TODAY_LOG_WEIGHT_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_WEIGHT_BUTTON", "TODAY_LOG_WEIGHT_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19380, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19248, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19828, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17512, 47),
      ))
    }

@delegate:ResourceContentHash(1_630_494_175)
public val Res.string.TODAY_MEALS_SECTION: StringResource by lazy {
      StringResource("string:TODAY_MEALS_SECTION", "TODAY_MEALS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19444, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19300, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19888, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17560, 43),
      ))
    }

@delegate:ResourceContentHash(274_484_107)
public val Res.string.TODAY_MEAL_PLAN_SECTION: StringResource by lazy {
      StringResource("string:TODAY_MEAL_PLAN_SECTION", "TODAY_MEAL_PLAN_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19496, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19352, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19936, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17604, 51),
      ))
    }

@delegate:ResourceContentHash(359_299_014)
public val Res.string.TODAY_WATER_INTAKE_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_LABEL", "TODAY_WATER_INTAKE_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19548, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19408, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19992, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17656, 48),
      ))
    }

@delegate:ResourceContentHash(-1_159_753_688)
public val Res.string.TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", "TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19597, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19461, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20049, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17705, 53),
      ))
    }

@delegate:ResourceContentHash(2_088_683_876)
public val Res.string.TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", "TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19659, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19515, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20103, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17759, 91),
      ))
    }

@delegate:ResourceContentHash(359_299_014)
public val Res.string.TODAY_WATER_INTAKE_SHEET_TITLE: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_TITLE", "TODAY_WATER_INTAKE_SHEET_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19755, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19607, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20215, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17851, 54),
      ))
    }

@delegate:ResourceContentHash(-1_084_134_679)
public val Res.string.TODAY_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WEIGHT_LABEL", "TODAY_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19810, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19666, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20278, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17906, 34),
      ))
    }

@delegate:ResourceContentHash(803_834_726)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", "TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19849, 327),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19701, 279),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20313, 315),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17941, 259),
      ))
    }

@delegate:ResourceContentHash(1_149_546_927)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", "TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20177, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19981, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20629, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18201, 67),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("MAIN_NAVIGATION_CHAT_LABEL", Res.string.MAIN_NAVIGATION_CHAT_LABEL)
  map.put("MAIN_NAVIGATION_DAILY_LABEL", Res.string.MAIN_NAVIGATION_DAILY_LABEL)
  map.put("MAIN_NAVIGATION_INSIGHTS_LABEL", Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL)
  map.put("MAIN_NAVIGATION_MAIN_LABEL", Res.string.MAIN_NAVIGATION_MAIN_LABEL)
  map.put("MAIN_NAVIGATION_ME_LABEL", Res.string.MAIN_NAVIGATION_ME_LABEL)
  map.put("MAIN_NAVIGATION_TODAY_LABEL", Res.string.MAIN_NAVIGATION_TODAY_LABEL)
  map.put("MEAL_PLAN_LOG_FOOD_BUTTON", Res.string.MEAL_PLAN_LOG_FOOD_BUTTON)
  map.put("MED_TODAY_SCREEN_TITLE", Res.string.MED_TODAY_SCREEN_TITLE)
  map.put("MED_TODAY_STEPS_FORMAT", Res.string.MED_TODAY_STEPS_FORMAT)
  map.put("ME_BMI_GOAL_VALUE_FORMAT", Res.string.ME_BMI_GOAL_VALUE_FORMAT)
  map.put("ME_CALORIES_HISTORY_SECTION", Res.string.ME_CALORIES_HISTORY_SECTION)
  map.put("ME_DAYS_IN_A_ROW_LABEL", Res.string.ME_DAYS_IN_A_ROW_LABEL)
  map.put("ME_DAYS_IN_A_ROW_VALUE", Res.string.ME_DAYS_IN_A_ROW_VALUE)
  map.put("ME_SCREEN_TITLE_FORMAT", Res.string.ME_SCREEN_TITLE_FORMAT)
  map.put("ME_WEIGHT_HISTORY_SECTION", Res.string.ME_WEIGHT_HISTORY_SECTION)
  map.put("ME_WEIGHT_LOSS_PROGRESS_SECTION", Res.string.ME_WEIGHT_LOSS_PROGRESS_SECTION)
  map.put("ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", Res.string.ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT)
  map.put("ONBOARDING_SIGN_IN_BUTTON", Res.string.ONBOARDING_SIGN_IN_BUTTON)
  map.put("ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", Res.string.ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON)
  map.put("ONBOARDING_WELCOME_SIGN_IN_BUTTON", Res.string.ONBOARDING_WELCOME_SIGN_IN_BUTTON)
  map.put("ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", Res.string.ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL)
  map.put("ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", Res.string.ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT)
  map.put("PAYWALL_OTHER_PLANS_BUTTON", Res.string.PAYWALL_OTHER_PLANS_BUTTON)
  map.put("PAYWALL_PRIVACY_BUTTON", Res.string.PAYWALL_PRIVACY_BUTTON)
  map.put("PAYWALL_RESTORE_BUTTON", Res.string.PAYWALL_RESTORE_BUTTON)
  map.put("PAYWALL_SIGN_IN_BUTTON", Res.string.PAYWALL_SIGN_IN_BUTTON)
  map.put("PAYWALL_TERMS_BUTTON", Res.string.PAYWALL_TERMS_BUTTON)
  map.put("PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", Res.string.PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT)
  map.put("PCOS_TODAY_LOG_SYMPTOMS_LABEL", Res.string.PCOS_TODAY_LOG_SYMPTOMS_LABEL)
  map.put("PERIOD_TRACKER_DAY_FORMAT", Res.string.PERIOD_TRACKER_DAY_FORMAT)
  map.put("PERIOD_TRACKER_LOG_BUTTON_DEFAULT", Res.string.PERIOD_TRACKER_LOG_BUTTON_DEFAULT)
  map.put("PERIOD_TRACKER_LOG_BUTTON_UNDEFINED", Res.string.PERIOD_TRACKER_LOG_BUTTON_UNDEFINED)
  map.put("PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE", Res.string.PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE)
  map.put("PERIOD_TRACKER_PERIOD_LATE_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_LATE_FORMAT)
  map.put("PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT)
  map.put("PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT)
  map.put("PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT)
  map.put("PILATES_TODAY_SCREEN_TITLE", Res.string.PILATES_TODAY_SCREEN_TITLE)
  map.put("PILATES_TODAY_WORKOUTS_SECTION", Res.string.PILATES_TODAY_WORKOUTS_SECTION)
  map.put("RATE_US_ALERT_MESSAGE", Res.string.RATE_US_ALERT_MESSAGE)
  map.put("RATE_US_ALERT_NEGATIVE_BUTTON", Res.string.RATE_US_ALERT_NEGATIVE_BUTTON)
  map.put("RATE_US_ALERT_POSITIVE_BUTTON", Res.string.RATE_US_ALERT_POSITIVE_BUTTON)
  map.put("RATE_US_ALERT_TITLE_FORMAT", Res.string.RATE_US_ALERT_TITLE_FORMAT)
  map.put("RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON)
  map.put("RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON)
  map.put("RATE_US_IMPROVE_ALERT_TITLE", Res.string.RATE_US_IMPROVE_ALERT_TITLE)
  map.put("RECIPE_INGREDIENTS_TITLE", Res.string.RECIPE_INGREDIENTS_TITLE)
  map.put("RECIPE_INGREDIENT_FORMAT", Res.string.RECIPE_INGREDIENT_FORMAT)
  map.put("RECIPE_NUTRITION_CALORIES", Res.string.RECIPE_NUTRITION_CALORIES)
  map.put("RECIPE_NUTRITION_CARBS", Res.string.RECIPE_NUTRITION_CARBS)
  map.put("RECIPE_NUTRITION_FAT", Res.string.RECIPE_NUTRITION_FAT)
  map.put("RECIPE_NUTRITION_FIBER", Res.string.RECIPE_NUTRITION_FIBER)
  map.put("RECIPE_NUTRITION_PER_100G", Res.string.RECIPE_NUTRITION_PER_100G)
  map.put("RECIPE_NUTRITION_PROTEIN", Res.string.RECIPE_NUTRITION_PROTEIN)
  map.put("RECIPE_PREPARATION_TITLE", Res.string.RECIPE_PREPARATION_TITLE)
  map.put("RECIPE_SERVING_SIZE_FORMAT", Res.string.RECIPE_SERVING_SIZE_FORMAT)
  map.put("SETTINGS_ABOUT_PRODUCT_LABEL", Res.string.SETTINGS_ABOUT_PRODUCT_LABEL)
  map.put("SETTINGS_CONTACT_US_LABEL", Res.string.SETTINGS_CONTACT_US_LABEL)
  map.put("SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE)
  map.put("SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_TITLE)
  map.put("SETTINGS_DELETE_ACCOUNT_LABEL", Res.string.SETTINGS_DELETE_ACCOUNT_LABEL)
  map.put("SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", Res.string.SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON)
  map.put("SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", Res.string.SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON)
  map.put("SETTINGS_GENERAL_SECTION", Res.string.SETTINGS_GENERAL_SECTION)
  map.put("SETTINGS_LEGAL_PRODUCT_LABEL", Res.string.SETTINGS_LEGAL_PRODUCT_LABEL)
  map.put("SETTINGS_LOGOUT_LABEL", Res.string.SETTINGS_LOGOUT_LABEL)
  map.put("SETTINGS_MANAGE_SUBSCRIPTION_LABEL", Res.string.SETTINGS_MANAGE_SUBSCRIPTION_LABEL)
  map.put("SETTINGS_MEAL_PLAN_LABEL", Res.string.SETTINGS_MEAL_PLAN_LABEL)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE)
  map.put("SETTINGS_METRICS_SYSTEM_LABEL", Res.string.SETTINGS_METRICS_SYSTEM_LABEL)
  map.put("SETTINGS_PERIOD_TRACKER_LABEL", Res.string.SETTINGS_PERIOD_TRACKER_LABEL)
  map.put("SETTINGS_PROFILE_AGE_LABEL", Res.string.SETTINGS_PROFILE_AGE_LABEL)
  map.put("SETTINGS_PROFILE_HEIGHT_LABEL", Res.string.SETTINGS_PROFILE_HEIGHT_LABEL)
  map.put("SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", Res.string.SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL)
  map.put("SETTINGS_PROFILE_NAME_LABEL", Res.string.SETTINGS_PROFILE_NAME_LABEL)
  map.put("SETTINGS_PROFILE_SECTION", Res.string.SETTINGS_PROFILE_SECTION)
  map.put("SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", Res.string.SETTINGS_PROFILE_TARGET_WEIGHT_LABEL)
  map.put("SETTINGS_SCREEN_TITLE", Res.string.SETTINGS_SCREEN_TITLE)
  map.put("SHOPPING_LIST_CATEGORY_ALL_LABEL", Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL)
  map.put("SHOPPING_LIST_CHECKED_SECTION", Res.string.SHOPPING_LIST_CHECKED_SECTION)
  map.put("SHOPPING_LIST_SCREEN_TITLE", Res.string.SHOPPING_LIST_SCREEN_TITLE)
  map.put("SHOPPING_LIST_UNCHECKED_SECTION", Res.string.SHOPPING_LIST_UNCHECKED_SECTION)
  map.put("TODAY_ACTIVITY_LABEL", Res.string.TODAY_ACTIVITY_LABEL)
  map.put("TODAY_LOGGED_SYMPTOMS_LABEL", Res.string.TODAY_LOGGED_SYMPTOMS_LABEL)
  map.put("TODAY_LOG_CONTROLS_SECTION", Res.string.TODAY_LOG_CONTROLS_SECTION)
  map.put("TODAY_LOG_FOOD_BUTTON", Res.string.TODAY_LOG_FOOD_BUTTON)
  map.put("TODAY_LOG_SYMPTOMS_LABEL", Res.string.TODAY_LOG_SYMPTOMS_LABEL)
  map.put("TODAY_LOG_WATER_BUTTON", Res.string.TODAY_LOG_WATER_BUTTON)
  map.put("TODAY_LOG_WEIGHT_BUTTON", Res.string.TODAY_LOG_WEIGHT_BUTTON)
  map.put("TODAY_MEALS_SECTION", Res.string.TODAY_MEALS_SECTION)
  map.put("TODAY_MEAL_PLAN_SECTION", Res.string.TODAY_MEAL_PLAN_SECTION)
  map.put("TODAY_WATER_INTAKE_LABEL", Res.string.TODAY_WATER_INTAKE_LABEL)
  map.put("TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", Res.string.TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON)
  map.put("TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", Res.string.TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL)
  map.put("TODAY_WATER_INTAKE_SHEET_TITLE", Res.string.TODAY_WATER_INTAKE_SHEET_TITLE)
  map.put("TODAY_WEIGHT_LABEL", Res.string.TODAY_WEIGHT_LABEL)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON)
}
